import { FaqsTopicsIcon } from "./FaqTopicsIcon";

function FaqsTopics({ topics, activeTopic, onClick }) {
  return (
    <aside className="content-faqs__topics" aria-label="FAQ Topics">
      <ul>
        {topics.map((topic) => (
          <li key={topic.id}>
            <button
              className={`topic-button ${activeTopic === topic.slug ? 'active' : ''}`}
              onClick={() => onClick(topic.slug)}
              aria-selected={activeTopic === topic.slug ? 'true' : 'false'}
              tabIndex={0}
            >
              <FaqsTopicsIcon icon={topic.icon} />
              {topic.name}
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default FaqsTopics;